import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import Button from "../../Button/Button";
import Modal from "../../Modal/Modal";
import "./ConfirmDeleteModal.css";

const ConfirmDeleteModal = ({ onClose, onConfirm, itemName }) => {
  const [inputValue, setInputValue] = useState("");

  const isConfirmEnabled = inputValue.trim().toUpperCase() === "DELETE";

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="danger"
        icon={<Trash2 size={15} />}
        onClick={onConfirm}
        disabled={!isConfirmEnabled}
      >
        Delete
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Delete Confirmation"
      maxWidth="460px"
      footer={footer}
    >
      <div>
        <p className="delete-confirm-message">
          Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.
        </p>
        <p className="delete-confirm-prompt">
          Please type <strong>DELETE</strong> to confirm.
        </p>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Type DELETE to confirm"
          className="delete-confirm-input"
        />
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;

